export const green = '#256230';
export const lightGreen = '#C4E945';
export const error = '#FF2A2A';
export const brightGreen = '#30B422';
export const fadedBrightGreen = '#30B4221A';
export const markerRed = '#AF1419'
export const linkBlue = '#15c';
